const EMAIL_TEMPLATES = [
  {
    id: "password-reset",
    name: "Password reset",
    action: "A user submits Forgot Password",
    recipient: "The account email address",
    from: "Envoy Dashboard <noreply@envoydashboard.com>",
    subject: "Reset your {{storeName}} password",
    previewText: "Use this link to choose a new password.",
    body: [
      "Hi {{name}},",
      "We received a request to reset the password for your account at {{storeName}}.",
      "Click the button below to choose a new password. This link expires in 24 hours.",
      "If you did not request this, you can ignore this email. Your password will stay the same.",
    ],
    cta: "Reset password",
  },
  {
    id: "user-created-dashboard",
    name: "Account created (Dashboard)",
    action: "An admin adds a manager or admin in User Management",
    recipient: "The new manager or admin",
    from: "Envoy Dashboard <noreply@envoydashboard.com>",
    subject: "Your Envoy Dashboard account has been created for {{storeName}}",
    previewText: "An Envoy Dashboard account was created for you.",
    body: [
      "Hi {{name}},",
      "An account was created for Envoy Dashboard at {{storeName}}.",
      "Restaurant: {{storeName}}",
      "Email: {{email}}",
      "Password: {{password}}",
      "Sign in to Envoy Dashboard with the email and password above. Please change your password after your first login.",
    ],
    cta: "Open Envoy Dashboard",
  },
  {
    id: "user-created-roster",
    name: "Account created (Roster)",
    action: "An admin adds an employee in User Management",
    recipient: "The new employee",
    from: "Envoy Dashboard <noreply@envoydashboard.com>",
    subject: "Your Envoy Roster System account has been created for {{storeName}}",
    previewText: "An Envoy Roster System account was created for you.",
    body: [
      "Hi {{name}},",
      "An account was created for Envoy Roster System at {{storeName}}.",
      "Restaurant: {{storeName}}",
      "Email: {{email}}",
      "Password: {{password}}",
      "Sign in to Envoy Roster System with the email and password above. Please change your password after your first login.",
    ],
    cta: "Open Envoy Roster System",
  },
  {
    id: "password-updated",
    name: "Password updated",
    action: "An admin changes a user's password",
    recipient: "That user",
    from: "Envoy Dashboard <noreply@envoydashboard.com>",
    subject: "Your {{storeName}} password was updated",
    previewText: "An administrator updated your password.",
    body: [
      "Hi {{name}},",
      "An administrator updated the password for your account at {{storeName}}.",
      "If you made this change, no further action is needed. If you did not expect this, contact your store manager immediately.",
    ],
    cta: null,
  },
  {
    id: "ticket-created",
    name: "Support ticket raised",
    action: "A manager or admin creates a support ticket",
    recipient: "Admins",
    from: "Envoy Dashboard <noreply@envoydashboard.com>",
    subject: "[{{storeName}}] New support ticket: {{ticketTitle}}",
    previewText: "A new ticket needs attention.",
    body: [
      "A new support ticket was raised for {{storeName}}.",
      "Ticket: {{ticketTitle}}",
      "Raised by: {{raisedBy}}",
      "Open the dashboard to review the request and assign it if needed.",
    ],
    cta: "View ticket",
  },
  {
    id: "ticket-assigned",
    name: "Ticket assigned",
    action: "An admin assigns a support ticket",
    recipient: "The assigned user",
    from: "Envoy Dashboard <noreply@envoydashboard.com>",
    subject: "[{{storeName}}] You've been assigned: {{ticketTitle}}",
    previewText: "A support ticket was assigned to you.",
    body: [
      "Hi {{name}},",
      "You have been assigned a support ticket for {{storeName}}.",
      "Ticket: {{ticketTitle}}",
      "Please review it and follow up with the person who raised it.",
    ],
    cta: "Open ticket",
  },
  {
    id: "ticket-reply",
    name: "Ticket reply",
    action: "A reply is added to a support ticket",
    recipient: "The person who raised the ticket",
    from: "Envoy Dashboard <noreply@envoydashboard.com>",
    subject: "[{{storeName}}] New reply on {{ticketTitle}}",
    previewText: "There's a new message on your ticket.",
    body: [
      "Hi {{name}},",
      "There's a new reply on your support ticket for {{storeName}}.",
      "Ticket: {{ticketTitle}}",
      "Open Envoy Dashboard to read the message and continue the conversation.",
    ],
    cta: "Read reply",
  },
];

export default EMAIL_TEMPLATES;
